import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './ArchivePage.module.scss'
import { Button, Layout } from "components/index";
import { getActivityLog } from 'service/ArchiveService'

function ArchivePage() {
  const navigate = useNavigate()
  const [stats, setStats] = useState({
    university: { total: 0, digitized: 0 },
    students: { total: 0, digitized: 0 },
    employees: { total: 0, digitized: 0 },
    logs: { total: 0 }
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadStats()
  }, [])

  const loadStats = async () => {
    try {
      setLoading(true)
      // Получаем статистику из API
      const activityData = await getActivityLog()
      setStats(prevStats => ({
        ...prevStats,
        logs: { total: activityData.length || 0 }
      }))
    } catch (error) {
      console.error('Ошибка при загрузке статистики:', error)
    } finally {
      setLoading(false)
    }
  }

  const archiveOptions = [
    {
      id: 'university',
      title: 'Архив университета',
      description: 'Административные документы, приказы, протоколы',
      color: 'blue',
      icon: '📁',
      stats: `${stats.university.total} дел • ${stats.university.digitized} оцифровано`
    },
    {
      id: 'students',
      title: 'Архив студентов',
      description: 'Личные дела студентов, ведомости, дипломы',
      color: 'green',
      icon: '👨‍🎓',
      stats: `${stats.students.total} дел • ${stats.students.digitized} оцифровано`
    },
    {
      id: 'employees',
      title: 'Архив сотрудников',
      description: 'Кадровые личные дела, трудовые договоры',
      color: 'orange',
      icon: '👨‍💼',
      stats: `${stats.employees.total} дел • ${stats.employees.digitized} оцифровано`
    },
    {
      id: 'logs',
      title: 'Журнал действий',
      description: 'История операций в архивной системе',
      color: 'purple',
      icon: '📊',
      stats: `${stats.logs.total} записей`
    }
  ]

  const handleArchiveSelect = (archiveId) => {
    navigate(`/archive/${archiveId}/`)
  }

  return (
    <Layout>
      <div className={styles.archive_page}>
        <div className={styles.header}>
          <h1>Архивная система</h1>
          <p className={styles.subtitle}>Выберите раздел архива для работы</p>
        </div>

        <div className={styles.quick_actions}>
          <button 
            className={styles.action_btn}
            onClick={() => navigate('/archive/students/')}
          >
            + Зарегистрировать студента
          </button>
          <button 
            className={styles.action_btn}
            onClick={() => navigate('/archive/employees/')}
          >
            + Создать дело сотрудника
          </button>
        </div>

        <div className={styles.archive_grid}>
          {archiveOptions.map((archive) => (
            <div
              key={archive.id}
              className={`${styles.archive_card} ${styles[`archive_card_${archive.color}`]}`}
              onClick={() => handleArchiveSelect(archive.id)}
            >
              <div className={styles.card_icon}>{archive.icon}</div>
              <h2 className={styles.card_title}>{archive.title}</h2>
              <p className={styles.card_description}>{archive.description}</p>
              <p className={styles.card_stats}>{archive.stats}</p>
              <div className={styles.card_action}>
                <span>Перейти →</span>
              </div>
            </div>
          ))}
        </div>

        {!loading && (
          <div className={styles.info_section}>
            <div className={styles.info_card}>
              <h3>💡 Информация</h3>
              <ul>
                <li>Все документы хранятся в соответствии с требованиями законодательства</li>
                <li>Срок хранения личных дел: 75 лет</li>
                <li>Регулярное резервное копирование данных</li>
                <li>Контроль доступа и журналирование всех операций</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </Layout>
  )
}

export default ArchivePage
